/**
 * Template: Press Page template
 * -----------------------------------------------------------------------------
 * Scripts to execute on the Press page.
 *
 */
import {load} from '@shopify/theme-sections';
import '../../styles/templates/page.press-room.scss';

import FeatureCarousel from '~/components/feature-carousel';
import PostListingItem from '~/components/post-listing-item';

document.addEventListener('DOMContentLoaded', () => {
  load('*');
  PostListingItem().init();
  FeatureCarousel().init();
});
